module.exports = __webpack_public_path__ + "static/headband_of_intellect-2ff74d926dc89f8eb5e93f83065c642b.jpeg";